import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { Button, IESAuthUtilV2 } from '@activehub/common-components-spa-resource';
import { IESConfig, IESOptions } from '../../constants/IESConfig';
import './PreLogin.scss';
import { useHistory } from 'react-router-dom';
import { Footer } from '../footer/Footer';
import PreLoginMobile from './PreLoginMobile';
import { footerLinks } from '../../constants/Config';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LiveChatButton from '../live-chat-button/LiveChatButton';

export default function PreLogin(props) {

    const [iesSession, setIesSession] = useState(null);
    const isMobile = !useMediaQuery('(min-width:768px)');
    const isTablet = useMediaQuery('(min-width:768px) and (max-width: 1180px)');
    const history = useHistory();
    useEffect(() => {
        localStorage.removeItem('isRedirectedToMat');  
        localStorage.removeItem('isRedirectedToAH');  
    }, []);
    const setClient = (e) => {
        sessionStorage.setItem("LOGINTYPE", e.target.id)
        iesSession.login();
    }

    useEffect(() => {
        const userIdKey = Object.keys(localStorage).find(key => key.includes('PiUserId'))
        const successUrl = window.location.href.includes('/login') ? window.location.href.split("#")[0] : window.location.href;
        if (localStorage.getItem(userIdKey)) {
            window.location.assign(successUrl);
        }
        console.log('successUrl', successUrl)
        const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
        const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
        const iesSubscription = IESAuthUtilV2.load({
            ...IESConfig,
            callbackURL: successUrl,
            domain: window.location.hostname,
            ...loginParams
        }, IESOptions).subscribe((session) => {
            console.count("IES Session")
            setIesSession(session);
        });

        return () => iesSubscription.unsubscribe();
    }, []);

    return (
        <>
            <Helmet>
                <title>ActiveHub</title>
            </Helmet>
            <LiveChatButton isAuthenticated={false} />
            {(isMobile || isTablet) ? <PreLoginMobile footerLinks={footerLinks} setClient={setClient} isMobile={isMobile} /> :
                <div className="row m-0 creation prelogin-desktop">
                    <div className="row m-0 creation__wrapleft w-100">
                        <div className="col-12 col-md-12 col-lg-10 p-0">
                            <div className="row">
                                <div className="col-12 col-md-12 activehub-text">
                                    <img src={`${process.env.PUBLIC_URL}/images/pearson-desktop-logo.svg`} alt="logo" className="pearson-logo" />
                                    <h1 className="creation__logo">ActiveHub</h1>
                                    <div className="creation__insights">Pinpoint where students are.</div>
                                    <div className="creation__insights creation__insights__guided">
                                    Then take them further.</div>
                                </div>
                                <div className='col-12 col-md-12 col-lg-6 btn-wrapper'>
                                    <div className='row m-0 w-100'>
                                        <div className="col-12 col-md-12 col-lg-12 p-0">
                                            <Button
                                                useButtonClass={false}
                                                ariaDescribedby={"signIn"}
                                                onClick={setClient}
                                                className={`sign-in`}>
                                                <span className='sign-in-text'>Sign in</span>
                                            </Button>
                                            <div className='horizontal-line'>
                                                <div className='line'></div>
                                                <div>or</div>
                                                <div className='line'></div>
                                            </div>
                                            <Button
                                                useButtonClass={false}
                                                ariaDescribedby={"RegisterAccessCode"}
                                                onClick={()=>{history.push(`/access-code-registration`)}}
                                                className={`register-access-code`}>
                                                <span className='register-text'>Register with an access code</span>
                                            </Button>
                                            <p id="signIn" aria-hidden="true" style={{ display: "none" }}>
                                                Sign in button
                                            </p>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-12 p-0 mt-link">
                                            <span className='links mr-5'><a rel='noreferrer' target="_blank" href='https://www.pearsonschoolsandfecolleges.co.uk/activehub'>Find out more</a></span>
                                            <span className='links'><a rel='noreferrer' href='https://support.pearson.com/uk/s/digital-contactus' target="_blank">Contact us</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-2 p-0 activehub-logo-container">
                            </div>

                    </div>
                    <div role="contentinfo" className="gwWraper_footer">
                        <Footer
                            footerLinks={footerLinks || []}
                        />
                    </div>
                </div>}
        </>
    )
}